import { BasicRequest } from "./basicRequest";

export class PreviewAllocationRequest extends BasicRequest{
    public allocationDefinitionId!:number;

    constructor(){
        super();
    }
}